import api from "../../services/api";

const useQueues = () => {
	const findAll = async () => {
        const { data } = await api.get("/team");
        return data;
    }

	return { findAll };
};

export default useQueues;
